import {requestWithKey} from "@/utils/request";
import endpoint from "@/config/endpoint";

export default {
  postEmailOTP: async(payload) => {
    try {
      const res = await requestWithKey.post(`${endpoint.EMAIL.OTP.MEMBER.EMAIL.VERIFICATION.POST}`, payload);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
};
